export default __webpack_public_path__ + "static/media/ARBURG_AUSBILDUNGLOGO.ddeeba99.jpg";